import { PatientsEffects } from './patients.effects';

export const PatientEffects = [PatientsEffects];
